export default __webpack_public_path__ + "static/media/04-fala.11bd4dca.mp4";